import { Component } from "@angular/core"
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms"
import { MatButtonModule } from "@angular/material/button"
import { MatCardModule } from "@angular/material/card"
import { MatFormFieldModule } from "@angular/material/form-field"
import { MatIconModule } from "@angular/material/icon"
import { MatInputModule } from "@angular/material/input"
import { SnackbarService } from "../../services/snackbar.service"
import { Router, RouterLink, RouterModule } from "@angular/router"
import { CognitoService } from "../../services/cognito.service"
import { LoadingSpinnerComponent } from "../../shared/loading-spinner/loading-spinner.component"
import { AuthFloatLabelDirective } from "../../directives/auth-float-label.directive"

@Component({
  selector: "app-reset-password",
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    RouterLink,
    ReactiveFormsModule,
    LoadingSpinnerComponent,
    AuthFloatLabelDirective,
  ],
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.css",
})
export class ResetPasswordComponent {
  resetForm: FormGroup
  loading = false
  error = ""
  success = ""

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private cognitoService: CognitoService,
    private snackbar: SnackbarService,
  ) {
    this.resetForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    })
  }

  onRequestReset() {
    if (this.resetForm.invalid) {
      return
    }

    this.loading = true
    this.error = ""
    this.success = ""

    const email = this.resetForm.get("email")?.value

    this.cognitoService.forgotPassword(email).subscribe({
      next: (response: any) => {
        this.loading = false
        this.success = "Password reset code sent to your email."
        this.snackbar.success("Reset code sent! Check your email.", 5000)

        this.router.navigate(["/verify-otp"], {
          queryParams: {
            email: email,
            type: "reset",
          },
        })
      },
      error: (error: any) => {
        this.loading = false
        this.error = error.error?.message || "Failed to send reset code. Please try again."
        this.snackbar.error(this.error, 5000)
      },
    })
  }

  get emailControl() {
    return this.resetForm.get("email")
  }
}
